// extracted by mini-css-extract-plugin
module.exports = {"deadline":"Deadline_deadline__ymAOy","autoWidth":"Deadline_autoWidth__l_jXG","deadlineLabel":"Deadline_deadlineLabel__gOmbl"};